import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({ name: "PayPalBanner" })
export default class PayPalBanner extends Vue {
    @Prop() readonly total: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public mounted() {
        let paypalScript = document.createElement("script");
        paypalScript.setAttribute("src", "https://www.paypal.com/sdk/js?client-id=AXM1RA-FPXu5gIS_K6B_LXmOMyjOsb2YFrRjeH4CMoDJWh_-TdnerNQQaGMH8G2yTMm5GmCaqfQ_kU6x&currency=EUR&components=messages");
        document.head.appendChild(paypalScript);
    }
};